import React from 'react';
import { VENDOR_PAYOUT_LEGEND_ADMIN, VENDOR_PAYOUT_LEGEND_VENDOR } from '../../utils/vendorPayoutStatus';

/** Short legend — same three states everywhere in admin. */
export function SimpleStatusLegend({ title = 'Booking status' }) {
  return (
    <div className="admin-status-legend admin-status-legend--simple">
      <strong className="admin-status-legend__title">{title}</strong>
      <ul className="admin-status-legend__list">
        <li><span className="badge badge-success">Paid</span> Money received — nothing owed</li>
        <li><span className="badge badge-warning">Waiting</span> Needs review, deposit, or final payment</li>
        <li><span className="badge badge-secondary">Cancelled</span> Closed — not running</li>
      </ul>
    </div>
  );
}

function PayoutLegendList({ items, title }) {
  return (
    <div className="admin-status-legend admin-status-legend--simple">
      <strong className="admin-status-legend__title">{title}</strong>
      <ul className="admin-status-legend__list">
        {items.map((row) => (
          <li key={row.label}>
            <span className={`badge badge-${row.badge}`}>{row.label}</span> {row.desc}
          </li>
        ))}
      </ul>
    </div>
  );
}

export function VendorPayoutLegendAdmin({ title = 'Payout status' }) {
  return <PayoutLegendList title={title} items={VENDOR_PAYOUT_LEGEND_ADMIN} />;
}

export function VendorPayoutLegendVendor({ title = 'Payout status' }) {
  return <PayoutLegendList title={title} items={VENDOR_PAYOUT_LEGEND_VENDOR} />;
}

export function GroupStatusLegend() {
  return <SimpleStatusLegend title="Group & shared rentals" />;
}

export function PrivateStatusLegend() {
  return <SimpleStatusLegend title="Private tours" />;
}
